<template>
  <div>
    <template v-if="wLG === false && wXL === false">
      <li v-for="(item, index) in fixedlinks" :key="'fixedlinks' + index" @click="togglemenu()">
        <div class="menuitemMobileMenu">
          <span class="linkMobileMenu">
            <a
              :id="'fixedLinkedID' + item.tblMenuItemID"
              @click="Startpageloading(item)"
              v-if="!MakeVueLink(item.tblMenuItemLink)"
              :class="
                'BSmenulink' + ' menuItem' + item.tblMenuItemID + ' ' + getmenuactive('menuItem' + item.tblMenuItemID)
              "
              :href="item.tblMenuItemLink"
              :target="item.tblMenuItemTarget"
              :onclick="item.tblMenuItemOnclickScript"
              >{{ item.menuItemName }}</a
            >
            <router-link
              v-if="MakeVueLink(item.tblMenuItemLink)"
              @click="Startpageloading(item)"
              :to="item.tblMenuItemLink"
              :class="
                'BSmenulink' + ' menuItem' + item.tblMenuItemID + ' ' + getmenuactive('menuItem' + item.tblMenuItemID)
              "
              >{{ item.menuItemName }}</router-link
            >
          </span>
        </div>
      </li>
    </template>
    <div id="usr_fixedLinks" class="fixedLinks" v-if="wLG === true || wXL === true">
      <span class="fixedLinks_CurrentUser vuefixedlink">{{ userInfo.currentUser }}</span>
      <span class="vuefixedlink" v-if="userInfo.currentExtOrg">{{ userInfo.currentExtOrg }}</span>
      <span
        class="fixedLinks_CurrentProfGroup vuefixedlink"
        v-if="userInfo.currentProfGroup != null"
        v-html="userInfo.currentProfGroup"
      ></span>
      <span
        class="spanFixedLinksMeldingen vuefixedlink"
        v-if="userInfo.messagesTotal != null && userInfo.messagesTotal != 0"
      >
        <font-awesome-layers class="desktopmailicon pointer">
          <font-awesome-icon :icon="['fal', 'envelope']" @click="openmail()" />
          <font-awesome-icon
            icon="circle"
            transform="shrink-9 left-7 up-5"
            v-if="userInfo.messagesUnread != 0"
            class="mailwhitedot"
          />
          <font-awesome-icon
            icon="circle"
            transform="shrink-10 left-7 up-5"
            v-if="userInfo.messagesUnread != 0"
            class="mailreddot"
          />
        </font-awesome-layers>

        <a id="aFLlMessages" :href="userInfo.mailurl" class="lnkToMessages lnkToMessagesUnread"
          >{{ translation(6232) }} ({{ userInfo.messagesUnread }})</a
        >
      </span>
      <span class="spanFixedLinksWisselProfgroup vuefixedlink" v-if="userInfo.currentProfGroup != null">
        <a id="lnkWisselProfgroup" href="#" class="lnkWisselProfgroup" @click="toggleprofgroupListVisible">{{
          translation(14)
        }}</a>
      </span>
      <span class="vuefixedlink" v-if="userInfo.systeemInfo != ''">
        <a href="#" @click="showsysteminfo" class="lnkAbout">{{ translation(10061) }}</a>
      </span>
      <span class="vuefixedlink" v-for="(filink, index) in fixedlinks" :key="index">
        <a
          :id="'fixedLinkedID' + filink.tblMenuItemID"
          :href="filink.tblMenuItemLink"
          :target="filink.tblMenuItemTarget"
          >{{ filink.menuItemName }}</a
        >
      </span>
      <span class="vuefixedlink" v-if="userInfo.logouturl != ''">
        <a :href="userInfo.logouturl" @click="Logout()">{{ userInfo.logouttext }}</a>
      </span>
      <!-- <span class="vuefixedlink">
            <div id="divWisselProfgroup" class="divWisselProfgroup" style="display: none;">
      </div>-->
      <div id="divWisselProfgroupVue" class="divFadeInit" v-if="profgroupListVisible">
        <a
          v-for="(pg, index) in profgroupList.filter((pg) => userInfo.currentProfGroupID != pg.tblProfGroupID)"
          @click="
            toggleprofgroupListVisible()
            changeProfGroup(pg.tblProfGroupID)
          "
          :key="index"
          class="lbtWisselProfgroup"
          v-html="pg.profGroupName"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { FAMixin, EventBus } from 'pevueglobal'
export default {
  mixins: [FAMixin],
  name: 'XVmenuFixedlinks',
  computed: {
    ...mapGetters(['userInfo', 'fixedlinks', 'profgroupList', 'profgroupListVisible', 'submenuitems']),
  },
  methods: {
    ...mapMutations(['toggleprofgroupListVisible', 'addNotification']),
    ...mapActions(['changeProfGroup', 'Logout']),
    openmail() {
      window.location = this.userInfo.mailurl
    },
    showsysteminfo() {
      const info = JSON.parse(this.userInfo.systeemInfo)[0]

      let mes = ''
      for (var propt in info) {
        mes += `<br>${propt} : ${info[propt]}`
      }
      mes += `<br>PE versie : ${PEGLOBALS.PEVersie}`

      this.addNotification({
        message: mes,
      })
    },
    Startpageloading(item) {
      if (item.tblMenuItemLink !== '#' || item.tblMenuItemOnclickScript !== null) {
        if (item.tblMenuItemTarget === null) {
          EventBus.$emit('updateloading', 1, false, true)
        }
      }
    },
  },
  props: ['MakeVueLink', 'getmenuactive', 'hasSubitem', 'togglemenu'],
}
</script>

<style scoped></style>
